import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@optsolservices/ngx-notification';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { PrintTriggerDialogComponent } from 'src/app/shared/print-trigger-dialog/print-trigger-dialog.component';

export interface SendEmailDialogData {

}

@Component({
  selector: 'app-gtr-receive-dialog',
  templateUrl: './gtr-receive-dialog.component.html',
  styleUrls: ['./gtr-receive-dialog.component.scss']
})
export class GtrReceiveDialogComponent implements OnInit {
  lines: any[];

  shortReceiveReasons: {
    value: string;
    display: string;
  }[];

  constructor(
    public dialogRef: MatDialogRef<GtrReceiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private baseService: BaseService,
  ) { }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_gtr_header_gtr_receive_dialog_config', { gtrReference: this.data.gtrReference, sourceWarehouseCode: this.data.sourceWarehouseCode, targetWarehouseCode: this.data.targetWarehouseCode })
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.lines = response.data?.lines;
          this.shortReceiveReasons = response.data?.shortReceiveReasons;
        }
      });
  }

  receive() {
    // Simple validation
    let hasError = false;
    this.lines.forEach(line => {
      if (line.qty > line.availableToReceiveQty) {
        this.notificationService.error('One or more lines has a receive quantity > available quantity to receive');
        hasError = true;
      } else if (line.qty < 0) {
        this.notificationService.error('One or more lines has a negative receive quantity');
        hasError = true;
      } /*else if (line.qty < line.availableToReceiveQty && (line.note === null || line.note === undefined)) {
        this.notificationService.error('One or more lines is short received, but no reason is provided');
        hasError = true;
      }*/
    });

    if (!hasError) {
      const dialogData: OiGroupDialogData = {
        title: 'Receiving GIT in Syspro',
        function: 'portal_oi_group_gtr_header_receive_gtr',
        postBody: {
          gtrReference: this.data.gtrReference,
          sourceWarehouseCode: this.data.sourceWarehouseCode,
          targetWarehouseCode: this.data.targetWarehouseCode,
          transactionDate: new Date(),
          note: this.data.note,
          lines: this.lines,
        }
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('GIT Received in Syspro');
          this.generateReceiptDocument();
        }
      });
    }
  }

  generateReceiptDocument() {
    this.baseService.executeCommand<any>('portal_sct_header_receipt_document_config', {
      gtrReference: this.data.gtrReference,
      sourceWarehouseCode: this.data.sourceWarehouseCode,
      targetWarehouseCode: this.data.targetWarehouseCode,
    })
      .subscribe(
        response => {
          if (response.responseCode === 0) {
            this.notificationService.success('Downloading Receipt Document');
            this.baseService.generateReport(response.data.generateReportConfig);
            this.dialogRef.close(true);
          } else {
            this.dialogRef.close(true);
          }
        },
        error => {
          this.dialogRef.close(true);
        });

  }

  qtyChange(dataItem: any) {
    // Clear the note if there is no discrepency of
    if (dataItem.qty === dataItem.availableToReceiveQty) {
      dataItem.note = null;
    }
  }

}
